<template lang="">
    <div>
        <vx-card cardBorder noShadow class="my-3" title="Check DHL Product(s) & Availability" id="dhl-product-check">
            <span v-if="!isAllRequiredFieldsFilled || !dhl_form.plannedShippingDateAndTime" class="text-danger block mb-3">*Note: Please fill the planned shipping date and package details before check the availability</span>
            <vs-button :disabled="!isAllRequiredFieldsFilled || !dhl_form.plannedShippingDateAndTime" @click.stop="checkRates" type="border">Check Products & Rates</vs-button>
            <span class="block my-3 text-danger font-bold">{{ error }}</span>
            <br>

            <div class="vx-row" v-if="!error">
                <div class="vx-col w-1/2 mb-3" v-for="(product, index) in available_products" :key="index">
                    <vx-card cardBorder noShadow :title="product.productName">
                        <template slot="actions">
                            <div class="flex">
                                <vs-radio v-model="selected_product" :vs-value="product"></vs-radio>
                                <span class="block text-primary font-bold" v-if="product.productCode === selected_product.productCode">selected</span>
                            </div>
                        </template> 
                        Product Code: <span class="font-bold">{{ product.productCode }}</span> <br>
                        Estimated Cost (GBP): <span class="font-bold">{{ product.totalPrice }}</span> <br>
                        Estimated Delivery: <span class="font-bold">{{ __dateTimeFormatter(product.estimatedDeliveryDateAndTime) }} </span><br>
                    </vx-card>
                </div>
            </div>
        </vx-card>
        
    </div>
</template>
<script>

import { RepositoryFactory } from "@/repository/RepositoryFactory";
const DHLRepository = RepositoryFactory.get('dhl')
import { mapGetters } from "vuex";
import moment from "moment";

export default {
    name: "DhlProductCheck",
    data() {
        return {
            results: [],
            error: '',
            available_products: [],
            selected_product: {
                productName: '',
                productCode: '',
                totalPrice: '',
                estimatedDeliveryDateAndTime: ''
            }
        }
    },
    props: {
        dhl_form: {
            default: () => ({}),
            type: Object,
            required: true
        },
        shipment_form: {
            default: () => ({}),
            type: Object,
            required: true
        },
        package_details: {
            default: () => ([]),
            type: Array,
            required: true
        }
    },
    methods: {
        //legacy
        async onClickCheckAvailability() {
            this.$vs.loading({
                container: '#dhl-product-check',
                scale: 0.45
            })
            this.results = []
            this.available_products = []
            this.error = ''
            for (let index = 0; index < this.package_details.length; index++) {
                const pkg = this.package_details[index]
                let paramsObj = {
                    originCountryCode: this.pickCountryCode(this.dhl_form.customerDetails.shipperDetails.postalAddress.countryCode),
                    originCityName: this.dhl_form.customerDetails.shipperDetails.postalAddress.cityName,
                    destinationCountryCode: this.pickCountryCode(this.shipment_form.delivery_address.country),
                    destinationCityName: this.shipment_form.delivery_address.town_state,
                    weight: Number(pkg.gross_weight),
                    length: Number(pkg.cubic_meter_lenght),
                    width: Number(pkg.cubic_meter_width),
                    height: Number(pkg.cubic_meter_height),
                    plannedShippingDate: moment(this.dhl_form.plannedShippingDateAndTime).format('YYYY-MM-DD'),
                    isCustomsDeclarable: null,
                    unitOfMeasurement: "metric",
                    nextBusinessDay: true
                };
                paramsObj.isCustomsDeclarable = paramsObj.originCountryCode !== paramsObj.destinationCountryCode
                const queryString = new URLSearchParams(paramsObj).toString();
                try {
                    const res = await DHLRepository.checkAvailableProducts(queryString);

                    const { data } = res.data; // based on your response structure

                    this.results.push({
                        index,
                        item_number: pkg.item_number,
                        success: true,
                        products: data.products
                    });
                } catch (error) {
                    this.error = (error && error.response && error.response.data && error.response.data.data && error.response.data.data.errors && error.response.data.data.errors.detail)
                        || (error && error.response && error.response.data && error.response.data.message)
                        || (error && error.response && error.response.data && error.response.data.error)
                        || (error && error.message)
                        || 'An error occurred while checking product availability.'
                }
            }
            this.available_products = this.getCommonProducts(this.results)
            if(this.available_products.find(pro => pro.productCode === 'N')) {
                this.product_code = 'N'
            } else {
                this.product_code = ''
            }

            this.$vs.loading.close('#dhl-product-check > .con-vs-loading')
        },
        async checkRates() {
            this.$vs.loading({
                container: '#dhl-product-check',
                scale: 0.45
            })
            try {
                this.results = []
                this.available_products = []
                this.error = ''
                this.selected_product = {
                    productName: '',
                    productCode: '',
                    totalPrice: '',
                    estimatedDeliveryDateAndTime: ''
                }

                let payload = {
                    customerDetails: {
                        shipperDetails: {
                            postalCode: this.dhl_form.customerDetails.shipperDetails.postalAddress.postalCode,
                            cityName: this.dhl_form.customerDetails.shipperDetails.postalAddress.cityName,
                            countryCode: this.pickCountryCode(this.dhl_form.customerDetails.shipperDetails.postalAddress.countryCode)
                        },
                        receiverDetails: {
                            postalCode: this.shipment_form.delivery_address.postcode,
                            cityName: this.shipment_form.delivery_address.town_state,
                            countryCode: this.pickCountryCode(this.shipment_form.delivery_address.country),
                        },
                    },
                    plannedShippingDateAndTime: moment(this.dhl_form.plannedShippingDateAndTime).format("YYYY-MM-DD[T]HH:mm:ss[GMT]Z"),
                    unitOfMeasurement: 'metric',
                    isCustomsDeclarable: false,
                    ...(this.dhl_form && this.dhl_form.valueAddedServices && this.dhl_form.valueAddedServices.length > 0 ? { valueAddedServices: this.dhl_form.valueAddedServices } : {}),
                    packages: this.package_details.map((pkg) => {
                        return {
                            weight: Number(pkg.gross_weight),
                            dimensions: {
                                length: Number(pkg.cubic_meter_lenght),
                                width: Number(pkg.cubic_meter_width),
                                height: Number(pkg.cubic_meter_height),
                            }
                        }
                    })
                }
                const { data } = (await DHLRepository.checkShipmentRates(payload)).data
                const products = (data && data.products) || []
                this.available_products = products.map((product) => {
                    const priceObj = (product.totalPrice || []).find(x => x.priceCurrency === 'GBP')
                        || (product.totalPrice || []).find(x => x.currencyType === 'BILLC')
                        || (product.totalPrice || [])[0]
                    return {
                        productName: product.productName,
                        productCode: product.productCode,
                        totalPrice: priceObj && priceObj.price !== undefined ? priceObj.price : 0,
                        estimatedDeliveryDateAndTime: product.deliveryCapabilities ? product.deliveryCapabilities.estimatedDeliveryDateAndTime : ''
                    }
                })
            } catch (error) {
                this.error = (error && error.response && error.response.data && error.response.data.data && error.response.data.data.errors && error.response.data.data.errors.detail)
                    || (error && error.response && error.response.data && error.response.data.message)
                    || (error && error.response && error.response.data && error.response.data.error)
                    || (error && error.message)
                    || 'An error occurred while checking products and rates.'
            } finally {
                this.$vs.loading.close('#dhl-product-check > .con-vs-loading')
            }
        },
        pickCountryCode(country) {
            if (country === 'United Kingdom') {
                return 'GB'
            }
            const find = this.countries.find(co => co.name === country)
            return find ? find.iso_code : country
        },
        getCommonProducts(allObjects) {
            if (!allObjects.length) return [];
            // take product names from first object
            let commonSet = new Set(allObjects[0].products.map(p => p.productName));
            // intersect with remaining objects
            for (let i = 1; i < allObjects.length; i++) {
                const currentSet = new Set(allObjects[i].products.map(p => p.productName));
                commonSet = new Set([...commonSet].filter(name => currentSet.has(name)));
            }
            // return common product objects (from first object)
            return allObjects[0].products.filter(p => commonSet.has(p.productName));
        }
    },
    computed: {
        ...mapGetters(["countries"]),
        isAllRequiredFieldsFilled() {
            const requiredKeys = [
                "item_number",
                "gross_weight",
                "cubic_meter_lenght",
                "cubic_meter_width",
                "cubic_meter_height"
            ];

            return this.package_details.every(obj =>
                requiredKeys.every(key => String(obj[key] || "").trim() !== "")
            );
        }
    },
    watch: {
        selected_product: {
            deep: true,
            handler(val) {
                this.$emit("update-product-code", val)
            }
        },
        error: {
            deep: true,
            handler(val) {
                this.$emit("update-error", val)
            }
        }
    }
}
</script>
<style lang="">

</style>